import PropTypes from 'prop-types';
import MasterListComponent from 'modules/shared/masterList/components/MasterListComponent';

const MasterListContainer = props => <MasterListComponent {...props} />;

MasterListContainer.propTypes = {
  stringsData: PropTypes.shape({}).isRequired,
};

MasterListContainer.defaultProps = {};

export default MasterListContainer;
